import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectGroups, selectGroupsLoaded } from "../features/auth/authSlice";
import Profile from "../pages/Profile";
import Dashboard from "../pages/Dashboard";
import ErrorPage from "../pages/ErrorPage";
import QueryBuilder from "../pages/QueryBuilder";
import RWEAIQueryBuilder from "../pages/RWEAIQueryBuilder";
import SavedQueries from "../pages/SavedQueries";
import QueryResult from "../pages/QueryResult";
import Feedback from "../pages/Feedback";
import Changelog from "../pages/Changelog";
import Faq from "../pages/Faq.js";
import Variation2 from "../pages/Variation2";
import HowTos from "../pages/HowTos.js";
import DataOverview from "../pages/DataOverview.js";
import RecentChanges from "../pages/RecentChanges";
import AdminPortal from "../pages/AdminPortal";
import DataDeIdentification from "../pages/DataDeIdentification";

const AdminRoute = ({ element }) => {
  const groups = useSelector(selectGroups);
  const groupsLoaded = useSelector(selectGroupsLoaded);
  if (!groupsLoaded) return null;
  if (groups.length === 0) return <Navigate to="/" replace />;
  return element;
};

const RoutesConfig = ({ signOut, user, handleMenuSelection }) => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/changelog" element={<Changelog />} />
      <Route path="/recentchanges" element={<RecentChanges />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/feedback" element={<Feedback />} />
      <Route path="/data-overview" element={<DataOverview />} />
      <Route path="/how-to" element={<HowTos />} />
      <Route
        path="/profile"
        element={<Profile signOut={signOut} user={user} />}
      />
      <Route path="/queryBuilder" element={<QueryBuilder />} />
      <Route path="/variation2" element={<Variation2 />} />
      <Route path="/queryBuilder/:queryId" element={<QueryBuilder />} />
      <Route
        path="/savedqueries"
        element={<SavedQueries handleMenuSelection={handleMenuSelection} />}
      />
      <Route path="/queryresults" element={<QueryResult />} />
      <Route path="/rwe-ai" element={<AdminRoute element={<RWEAIQueryBuilder />} />} />
      <Route path="/admin" element={<AdminRoute element={<AdminPortal />} />} />
      <Route path="/data-deidentification" element={<DataDeIdentification />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export default RoutesConfig;
